import {Component} from 'panel';

import {getReportUrl} from 'common/report/util';
import {registerMPElement} from 'common/util/register-element';
import {NavReport} from '../types';

import template from './index.jade';

class ReportsMenu extends Component<{}> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      open: `boolean`,
      order: `json`,
      'project-id': `number`,
      reports: `json`,
      'two-column': `boolean`,
      'workspace-id': `number`,
    };
  }

  get config() {
    return {
      template,
      helpers: {
        getReportUrl,

        getReports: () => this.attr(`order`).map((r) => this.attr(`reports`)[r]),

        getClassSuffix: (report: NavReport) => {
          // make sure to just use 'messages' from 'triggers/messages' and similar urls
          return (report.endpoint || ``).split(`/`).slice(-1)[0];
        },

        splitReportsInHalf: (reports: NavReport[]) => {
          const sliceIdx = Math.ceil(reports.length / 2);
          return [reports.slice(0, sliceIdx), reports.slice(sliceIdx)];
        },

        handleDropMenuChange: (ev) => {
          ev.stopImmediatePropagation();
          if (ev.detail.state === `closed`) {
            this.setAttribute(`open`, `false`);
          }
        },
      },
    };
  }
}

registerMPElement(`mp-reports-menu`, ReportsMenu);
